import { render, staticRenderFns } from "./listar-pessoas.vue?vue&type=template&id=293ed428&"
import script from "./listar-pessoas.vue?vue&type=script&lang=ts&"
export * from "./listar-pessoas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('293ed428')) {
      api.createRecord('293ed428', component.options)
    } else {
      api.reload('293ed428', component.options)
    }
    module.hot.accept("./listar-pessoas.vue?vue&type=template&id=293ed428&", function () {
      api.rerender('293ed428', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pessoa/listar-pessoas.vue"
export default component.exports